import { FC, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { IBrockmanBankDto } from "../../types/brockman/IBrockmanBankDto"
import { getStorageUrl } from "../../lib/helper"

type Props = {
  isManager?: boolean
}

export const Brockman: FC<Props> = ({ isManager }) => {
  const navigate = useNavigate()
  const [banks, setBanks] = useState<IBrockmanBankDto[]>([])

  useEffect(() => {
    TrinityAPI.getBrockmanBanks(response => {
      if (response.status === 200) {
        setBanks(response.data)
      }
    })
  }, [])

  return (
    <section className="add-more-block">
      <div className="flex-row-justify">
        <h3 className="heading-chapter">Банки и доп. соглашения</h3>
      </div>
      <ul className="block-grey-three">
        {banks.map((b, index) => (
          <li
            className="three-cards"
            key={index}
            onClick={() => navigate(`/${isManager ? "manager" : "admin"}/brockman/${b.id}`)}
          >
            <img src={`${getStorageUrl()}/${b.avatarPath}`} alt="" className="logo-bank-img" />
            <div className="flex-column-5">
              <p className="text-cointract-bank">{b.name}</p>
              <p className="text-cointract-detail-name">{b.brockmanDetail?.name}</p>
            </div>
          </li>
        ))}
      </ul>
      {!isManager && (
        <button className="btn" id="admin01" onClick={() => navigate("/admin/brockman/new")}>
          Добавить
        </button>
      )}
    </section>
  )
}
